<template>
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <ul class="nav nav-tabs w-100 justify-content-center" id="myTab" role="tablist">
                    <li class="nav-item flex-fill text-center">
                        <a class="nav-link active" id="message-tab" data-toggle="tab" href="#message" role="tab"
                            aria-controls="message" aria-selected="true">Log History Chat Terkirim</a>
                    </li>
                    <li class="nav-item flex-fill text-center">
                        <a class="nav-link" id="deviceLog-tab" data-toggle="tab" href="#deviceLog" role="tab"
                            aria-controls="deviceLog" aria-selected="false">Log History WhatsApp</a>
                    </li>
                </ul>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="message" role="tabpanel" aria-labelledby="message-tab">
                        <table id="messageTable" class="table table-striped table-bordered" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Status</th>
                                    <th>Riwayat Request WA</th>
                                    <th>No Telepon Tujuan</th>
                                    <th>Deskripsi Pesan</th>
                                </tr>
                            </thead>
                            <tbody>

                            </tbody>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="deviceLog" role="tabpanel" aria-labelledby="deviceLog-tab">
                        <table id="deviceLogTable" class="table table-striped table-bordered" style="width:100%;">
                            <thead>
                                <tr>
                                    <th>Status</th>
                                    <th>Riwayat Aktivitas</th>
                                </tr>
                            </thead>
                            <tbody>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { createTable } from "@/libs/hxcore";
import $ from "jquery";

export default {
    name: 'WhatsAppHistory',
    data() {
        return {
            phone: null,
            messageTable: null,
            deviceLogTable: null,
            messageData: [],
            deviceLogData: []
        };
    },
    mounted() {
        const self = this;
        this.messageTable = createTable('#messageTable', {
            title: '',
            data: this.messageData,
            ajax: '/whatsapp/message',
            frame: true,
			lengthChange: false,
			responsive: true,
			scrollX: true,
            processing: true,
            ordering: false,
            autoWidth: false,
			filter: false,
            language: {
                processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'
            },
            paramData: function (d) {
                d.sender_no = self.phone;
            },
            columns: [
                { data: 'success', render: function (data, type, row, meta) {
                    switch (data) {
                        case 0:
                            return '<span class="badge badge-warning">Pending</span>';
                        case 1:
                            return '<span class="badge badge-success">Terkirim</span>';
                        case 2:
                            return '<span class="badge badge-danger">Gagal</span>';
                    }
				} },
                { data: 'sent_at', render: function (data, type, row, meta) {
                    const options = { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' };
                    const createdAt = row.created_at != null ? (new Date(row.created_at)).toLocaleDateString('id-ID', options) : '';
                    const sentAt = data != null ? (new Date(data)).toLocaleDateString('id-ID', options) : '';

                    switch (row.success) {
                        case 0:
                            return `Pending ${createdAt}`;
                        case 1:
                            return `Terkirim ${sentAt}`;
                        case 2:
                            return `Gagal ${createdAt}`;
                    }
                } },
                { data: 'recipient_no' },
                { data: 'message' }
            ]
        });
        this.deviceLogTable = createTable('#deviceLogTable', {
            title: '',
            data: this.deviceLogData,
            ajax: '/whatsapp/device_log',
            frame: true,
			lengthChange: false,
			responsive: true,
			scrollX: true,
            processing: true,
            ordering: false,
            autoWidth: false,
			filter: false,
            language: {
                processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'
            },
            paramData: function (d) {
                d.sender_phone = self.phone;
            },
            columns: [
                { data: 'status', render: function (data, type, row, meta) {
                    switch (data) {
                        case 0:
                            return '<span class="badge badge-danger">Disconnect</span>';
                        case 1:
                            return '<span class="badge badge-success">Connect</span>';
                    }
                } },
                { data: 'created_at', render: function (data, type, row, meta) {
                    const date = new Date(data);
                    const options = { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' };
                    const formattedDate = date.toLocaleDateString('id-ID', options);

                    switch (row.status) {
                        case 0:
                            return `Disconnect ${formattedDate}`;
                        case 1:
                            return `Connect ${formattedDate}`;
                    }
                 } }
            ]
        });

        self.messageTable.api().columns.adjust();
        self.deviceLogTable.api().columns.adjust();

        $('a[data-toggle="tab"]').on('shown.bs.tab', function(e){
            const target = $(e.target).attr("href"); // Get the target tab
            if (target === '#message') {
                self.messageTable.api().columns.adjust();
            } else if (target === '#deviceLog') {
                self.deviceLogTable.api().columns.adjust();
            }
        });
    },
    methods: {
        refresh() {
            this.messageTable.api().ajax.reload();
            this.deviceLogTable.api().ajax.reload();
        }
    }
};
</script>
<style scoped>

</style>